'use client'

import { IconLogoMango } from 'icons/components/IconLogoMango'
import { IconLogoOutlet } from 'icons/components/IconLogoOutlet'
import type { IconProps } from 'icons/types/Icon.types'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import dynamic from 'next/dynamic'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { Device } from 'types/masterData'
import { Brand } from 'utils/pageTitles/pageTitle'

import { logoAltText } from '../utils/logoAltText'
import { LOGO_NAME, logoName } from '../utils/logoName'
import { logoSize } from '../utils/logoSize'

const IconLogoMng = dynamic<IconProps>(() =>
	import('icons/components/IconLogoMng').then((mod) => mod.IconLogoMng)
)

type LogoType = {
	[key in LOGO_NAME]: (props: IconProps) => React.ReactNode
}

const LogoIcon: LogoType = {
	[LOGO_NAME.Mango]: (props) => <IconLogoMango {...props} />,
	[LOGO_NAME.Outlet]: (props) => <IconLogoOutlet {...props} />,
	[LOGO_NAME.Mng]: (props) => <IconLogoMng {...props} />,
}

export const useLogoProperties = () => {
	const {
		channel,
		country: { mngLogo },
	} = useMasterData()
	const { isLargeOrGreater } = useResponsive()

	const name = logoName[channel][mngLogo ? Brand.Mng : Brand.Mango]
	const altText = logoAltText[channel][mngLogo ? Brand.Mng : Brand.Mango]
	const size =
		logoSize[channel][isLargeOrGreater ? Device.Desktop : Device.Mobile]
	const { width, height } = size

	return {
		name,
		altText,
		LogoComponent: LogoIcon[name || LOGO_NAME.Mango],
		width: width[mngLogo ? Brand.Mng : Brand.Mango],
		height: height[mngLogo ? Brand.Mng : Brand.Mango],
	}
}
